// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import PickupPromotionBanner from '@tcp/core/src/components/common/molecules/PickupPromotionBanner';
import withStyles from '../../../../../../common/hoc/withStyles';
import BOSSBannerStyle from '../styles/BossBanner.style';
import { getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';

export const getModifiedString = () => {
  const subHeading = `<span class="spanNoRush">${getDynamicLabelValues(
    'dynamic.cart.lbl_bossBanner_subHeadingDefault'
  )?.replace(
    '#type',
    `<b>${getDynamicLabelValues('dynamic.cart.lbl_bossBanner_noRush')}</b>`
  )}</span>`;
  return (
    // eslint-disable-next-line react/no-danger
    <span dangerouslySetInnerHTML={{ __html: subHeading }} />
  );
};
const BOSSBanner = ({ className, isATBModalBackAbTestNewDesign, isAddedToBagRedesign }) => {
  return (
    <React.Fragment>
      <div id="bossbanner" className={`${className}`}>
        <PickupPromotionBanner
          bossBanner
          fullBleed
          isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
          isAddedToBagRedesign={isAddedToBagRedesign}
        />
        <Row className="bossText">
          <Col
            className={`pickUp ${isAddedToBagRedesign ? 'elem-pl-MED_1 elem-pr-MED_1' : ''}`}
            key="productDetails"
            colSize={{ small: 6, medium: 8, large: 12 }}
          >
            <BodyCopy
              tag="span"
              fontSize={`${isAddedToBagRedesign ? 'fs12' : 'fs11'}`}
              textAlign="center"
              fontFamily="secondary"
              dataLocator="addedtobag-bossbannerdescription"
            >
              {getModifiedString()}
            </BodyCopy>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default withStyles(BOSSBanner, BOSSBannerStyle);
